// extracted by mini-css-extract-plugin
export var smallSpinner = "_py-0";